import { useEffect, useRef, useState } from "react";
import { Button, Input, message, Spin } from "antd";
import { serverFetch } from "@server";
import CyberMessage from "./cyber-message";
import "./cyber.css";

const CyberSpace = ({ spaceId }) => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [askText, setAskText] = useState("");
  const [sending, setSending] = useState(false);
  const messagesListRef = useRef(null);

  const getMessages = () => {
    if (!spaceId) return;
    setLoading(true);
    serverFetch("Cyber/messages", { queryParams: { spaceId } })
      .then((data) => {
        setMessages(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage || e.message || "Ошибка загрузки сообщений");
      });
  };

  useEffect(() => {
    getMessages();
  }, [spaceId]);

  const handleSend = () => {
    const text = askText.trim();
    if (!text) {
      message.warning("Введите вопрос");
      return;
    }
    setSending(true);
    serverFetch("Cyber/send", {
      method: "POST",
      bodyData: { spaceId: Number(spaceId), ask: text },
    })
      .then((newMsg) => {
        setMessages((prev) => [newMsg, ...prev]);
        setAskText("");
        message.success("Сообщение отправлено");
      })
      .catch((e) => {
        message.error(e.userMessage || e.message || "Ошибка отправки");
      })
      .finally(() => setSending(false));
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const reversed = [...messages].reverse();

  useEffect(() => {
    if (!loading && !messagesListRef.current) return;
    const el = messagesListRef.current;
    if (!el) return;

    const scrollToEnd = () => {
      el.scrollTop = el.scrollHeight;
    };
    scrollToEnd();
    requestAnimationFrame(scrollToEnd);

    const imgs = el.querySelectorAll("img");
    if (imgs.length === 0) return;

    let pending = imgs.length;
    const onDone = () => {
      pending--;
      if (pending <= 0) {
        scrollToEnd();
        requestAnimationFrame(scrollToEnd);
      }
    };

    imgs.forEach((img) => {
      if (img.complete) {
        onDone();
      } else {
        img.addEventListener("load", onDone);
        img.addEventListener("error", onDone);
      }
    });

    return () => {
      imgs.forEach((img) => {
        img.removeEventListener("load", onDone);
        img.removeEventListener("error", onDone);
      });
    };
  }, [loading, messages]);

  return (
    <div className="cyber-space-container">
      <div className="cyber-messages-list" ref={messagesListRef}>
        {loading ? (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <Spin />
          </div>
        ) : reversed.length > 0 ? (
          reversed.map((msg) => <CyberMessage key={msg.id} message={msg} />)
        ) : (
          <div style={{ textAlign: "center", padding: "40px", color: "#999" }}>
            Нет сообщений. Задайте первый вопрос.
          </div>
        )}
      </div>
      <div className="cyber-send-panel">
        <Input.TextArea
          value={askText}
          onChange={(e) => setAskText(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Введите вопрос..."
          rows={2}
          disabled={sending}
        />
        <Button
          type="primary"
          onClick={handleSend}
          loading={sending}
          disabled={!askText.trim() || sending}
        >
          Отправить
        </Button>
      </div>
    </div>
  );
};

export default CyberSpace;
